// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cookiePrivacyPolicyPopupStyles } from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import { hideElementOnPrint, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

cookiePrivacyPolicyPopupStyles.drawer = {
    position: "bottom",
    cssOverrides: {
        scrim: css`
            background-color: transparent;
            pointer-events: none;
        `,
        drawerTitle: css`
            display: none;
        `,
        drawerContent: css`
            padding: 15px 0;
            margin: 0 auto;
            width: 100%;
        `,
        drawerBody: css`
            box-shadow: 0px 100px 150px;
            pointer-events: all;
            height: 125px;
            ${hideElementOnPrint}
        `,
    },
    closeButtonProps: {
        css: css`
            display: none;
        `,
    },
    enableClickThrough: true,
};

cookiePrivacyPolicyPopupStyles.container = {
    gap: 10,
    css: css`
        margin: 0 auto;
        padding: 0 34px;
        ${xScreen("lte", "md")} {
            padding: 0 31px;
        }

        ${xScreen("lte", "sm")} {
            padding: 0 16px;
        }
        ${hideElementOnPrint}
    `,
};
cookiePrivacyPolicyPopupStyles.messageGridItem = {
    css: css`
        width: auto;
        flex-basis: auto;
        max-width: 70%;
        ${xScreen("lte", "md")} {
            max-width: 60%;
        }
        ${xScreen("lte", "sm")} {
            width: 100%;
            max-width: none;
        }
    `,
};
cookiePrivacyPolicyPopupStyles.closeButton = {
    css: css`
        width: 100%;
    `,
    variant: "secondary",
};

cookiePrivacyPolicyPopupStyles.acceptButton = {
    css: css`
        width: auto;
    `,
};
cookiePrivacyPolicyPopupStyles.closeGridItem = {
    css: css`
        width: auto;
        flex-basis: auto;
        max-width: none;
        &&& {
            margin-left: auto;
        }
        ${xScreen("lte", "sm")} {
            &&& {
                margin-left: 0;
            }
        }
    `,
};
cookiePrivacyPolicyPopupStyles.acceptGridItem = {
    css: css`
        order: 3;
        width: auto;
        flex-basis: auto;
        max-width: none;
        ${xScreen("lte", "sm")} {
            &&& {
                margin-left: auto;
            }
        }
    `,
};
cookiePrivacyPolicyPopupStyles.messageText = {
    variant: "p",
    css: css`
        margin-bottom: 0;
    `,
};
